// extracted by mini-css-extract-plugin
export default {"card":"FeatureCard_card__UD4Hm","avatar":"FeatureCard_avatar__cSpQA","button":"FeatureCard_button__0yRuM"};